import React from "react";
import { Modal } from "react-bootstrap";
import FormButton from "../Buttons/FormButton";

type CommonConfirmationModalProps = {
  show?: boolean;
  title?: string;
  content?: React.ReactNode;
  customClassName?: string;
  customClassNameForBody?: string;
  customClassNameForHeader?: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
  modalSize?: string;
  customClassNameForFooter?: string;
  showHeadingLine?: boolean;
  onModalSubmit?: (submit: boolean) => void;
};

const CommonConfirmationModal: React.FC<CommonConfirmationModalProps> = ({
  customClassName,
  confirmBtnText = "Done",
  cancelBtnText = "Cancel",
  show = false,
  title = "",
  content = "",
  modalSize = "modal-md",
  customClassNameForBody,
  customClassNameForFooter,
  onModalSubmit
}) => {
  const handleClose = () => {
    onModalSubmit?.(false);
  };
  return (
    <div className={`header-border ${customClassName}`}>
    <Modal
      show={show}
      onHide={
        handleClose
      }
      centered
      className={`${modalSize} custom-modal vewScanLogPadding`}
    >
      <Modal.Header
        closeButton
      >
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      {(title)? <hr className="my-0"></hr>:""}

      <Modal.Body className={`${customClassNameForBody} d-flex justify-content-center text-center py-5 fs-5`}>
        {content}
      </Modal.Body>

      <Modal.Footer className={`${customClassNameForFooter} d-flex justify-content-center`}>
        <FormButton
          className="sph-btn sph-shift me-2 cursor-pointer"
          handleClick={() => {
            onModalSubmit?.(false);
          }}
        >
          {cancelBtnText}
        </FormButton>
        <FormButton
          className="sph-btn me-2 cursor-pointer"
          handleClick={() => {
            onModalSubmit?.(true);
          }}
        >
          {confirmBtnText}
        </FormButton>
      </Modal.Footer>
    </Modal>
    </div>
  );
};

export default CommonConfirmationModal;
